import { useFetchRfqNew } from "../queries/hooks";
import useGetSelectedQuoteRevisionId from "./useGetSelectedQuoteRevisionId";

export default function useGetCurrentQuoteRevision() {
  const { data: rfq } = useFetchRfqNew();
  const selectedQuoteRevisionId = useGetSelectedQuoteRevisionId();

  if (!rfq) return undefined;

  const latestQuoteRevision = rfq.quote_revisions.sort(
    (a, b) => b.revision_number - a.revision_number,
  )[0];
  const selectedQuoteRevision = rfq.quote_revisions.find(
    ({ id }) => id === selectedQuoteRevisionId,
  );

  return selectedQuoteRevision ?? latestQuoteRevision;
}
